import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/youTubeShorts.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/Community/CommunityItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
